<template>
    <div :class="['chip', {warning}]">
        <p class="display-small-tiny"><slot></slot></p>
        <span class="remove-icon" @click="$emit('remove')" v-html="Icon.CROSS"></span>
    </div>
</template>
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Icon } from '@/front/icons';

@Component
export default class Chip extends Vue
{
    @Prop({type: Boolean, default: false}) readonly warning!: boolean;

    get Icon() {
        return Icon;
    }
}
</script>
<style lang="scss">
@import '~foundation-sites/scss/foundation';
@import '~scss/front/settings';

.chip {
    border-radius: var(--global-radius);
    border: 1px solid var(--light-gray);
    display: inline-block;
    padding: 2px 7px;

    &.warning {
        border-color: var(--warning);
        background-color: rgba(var(--warning), 0.14);
        color: var(--warning);

        .remove-icon {
            path {
                fill: rgba(var(--warning), 0.6);
            }

            &:hover {
                path {
                    fill: var(--warning);
                }
            }
        }
    }

    p {
        display: inline;
        position: relative;
        top: 1px;
        max-width: 230px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        display: inline-block;
        margin: 0;
    }

    .remove-icon {
        cursor: pointer;
        position: relative;
        top: 3px;

        path {
            fill: var(--gray);
        }

        &:hover {
            path {
                fill: var(--dark-gray);
            }
        }
    }
}

</style>
